// @flow
export const addValueToPreconfiguredFilter = (value: string, filter: Array<string>) => {
  if (value && !filter.includes(value)) {
    filter.push(value);
  }
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/addValueToPreconfiguredFilter.js